export const statesMap = new Map([
    ['ALL', 'Բոլորը'],
    ['CREATED', 'Դիմումը ստեղծված Է'],
    ['IDENTIFIED', 'Հարցման առկայություն'],
    ['CONFIRMED', 'Հաստատված'],
    ['ACCEPTED', 'Ընդունված հաճախորդի կողմից'],
    ['AGREED', 'Ավարտման ենթակա'],
    ['FINISHED', 'Ապրանքը բաց թողնված'],
    ['SIGNED', 'Պայմանագիրը ստորագրված'],
    ['FINALIZATION_BLOCKED', 'Պայմանագրի սխալ ստորագրություն'],
    ['DENIAL_BY_SHOP', 'Մերժում խանութից'],
    ['DENIAL_BY_CUSTOMER', 'Մերժում հաճախորդից'],
    ['GROUP', 'Մերժում համակարգից'],
    ['GROUP_FACEMATCH', 'Նույնականացման սխալ'],
    ['TIMEOUT', 'Ժամկետանց դիմում'],
    ['REQUEST_FAILED', 'Տեխնիկական խնդիր'],
]);

export const allStatesMap = new Map([
    ['CREATED', 'Դիմումը ստեղծված Է'],
    ['IDENTIFIED', 'Հարցման առկայություն'],
    ['DENIAL_BY_SHOP', 'Մերժում խանութից'],
    ['DENIAL_BY_CUSTOMER', 'Մերժում հաճախորդից'],
    ['CONFIRMED', 'Հաստատված'],
    ['ACCEPTED', 'Ընդունված հաճախորդի կողմից'],
    ['AGREED', 'Ավարտման ենթակա'],
    ['SIGNED', 'Պայմանագիրը ստորագրված'],
    ['FINISHED', 'Ապրանքը բաց թողնված'],
    ['FINALIZATION_BLOCKED', 'Պայմանագրի սխալ ստորագրություն'],
    ['REQUEST_FAILED', 'Տեխնիկական խնդիր'],
    ['TIMEOUT', 'Ժամկետանց դիմում'],
    ['DENIAL_BY_SCORING', 'Մերժում համակարգից'],
    ['DENIAL_BY_DISTRIBUTION', 'Մերժում համակարգից'],
    ['IDENTIFICATION_BLOCKED', 'Մերժում համակարգից'],
    ['DENIAL_BY_STOP_FACTOR', 'Մերժում համակարգից'],
    ['FACEMATCH_FAILED', 'Նույնականացման սխալ'],
    ['FACEMATCH_BLOCKED', 'Նույնականացման սխալ'],
    ['FACEMATCH_PENDING', 'Նույնականացման գործընթաց'],
]);